export const LANDING_TYPE_TO_TARIFF_NAME = {
  1: 'Разовый',
  2: 'Базовый',
  3: 'Оптимальный',
  4: 'Профессионал',
  5: 'Бизнес',
};

export const getTariffLandingTypeValue = (tariff) => {
  const rawValue = tariff?.landing_type ?? tariff?.landingType;
  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return null;
  }

  const parsed = Number(rawValue);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const getTariffLandingType = getTariffLandingTypeValue;

export const getTariffLandingQuery = (tariff) => {
  const landingType = getTariffLandingTypeValue(tariff);
  if (landingType) {
    return `type=${landingType}`;
  }
  if (tariff?.id) {
    return `tariff=${tariff.id}`;
  }
  return 'tariff=<uuid>';
};

export const getTariffLandingPath = (tariff) => `/confirm?${getTariffLandingQuery(tariff)}`;

export const getTariffLandingUrl = (tariff) => `${window.location.origin}${getTariffLandingPath(tariff)}`;

export const getTariffLandingLabel = (tariff) => getTariffLandingQuery(tariff);

export const buildTariffPreviewFromForm = (form, tariffId = null) => ({
  id: tariffId,
  landing_type: form.landing_type === '' || form.landing_type === null || form.landing_type === undefined
    ? null
    : Number(form.landing_type),
});

export const findTariffByPreselectedType = (tariffs, type) => {
  if (!type || !tariffs?.length) return null;

  const numericType = Number(type);
  if (!Number.isInteger(numericType) || numericType <= 0) return null;

  const byLandingType = tariffs.find(
    (tariff) => getTariffLandingTypeValue(tariff) === numericType
  );
  if (byLandingType) return byLandingType;

  const expectedName = LANDING_TYPE_TO_TARIFF_NAME[numericType];
  if (!expectedName) return null;

  return tariffs.find(
    (tariff) =>
      (tariff.name || '').toLowerCase() === expectedName.toLowerCase() ||
      (tariff.name || '').toLowerCase().includes(expectedName.toLowerCase())
  ) || tariffs[numericType - 1] || null;
};

export const findTariffById = (tariffs, tariffId) => {
  if (!tariffId || !tariffs?.length) return null;
  return tariffs.find((tariff) => tariff.id === tariffId) || null;
};
